module.exports = __webpack_public_path__ + "img/src/modules/web-agent/assets/img/maven-check.png?8fad17735a7c7d89b6c6ba23b88f9e26";